import React from 'react';
import { Spinner } from 'react-bootstrap';

const Loader = () => {
    return (
        <div style={{height:"100%", display:"flex", justifyContent:"center", alignItems:"center"}}>
            <Spinner animation="grow" variant="light" />
            {/* <Spinner animation="border" variant="secondary" /> */}
        </div>
    )
}

export default Loader;